import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  overflow-y: auto;
`;

export const LoadingWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70vh;
  width: 100%;
`;

export const EmptyEmoji = styled.span`
  font-size: 40px;
  text-align: center;
  margin-bottom: 16px;
`;

export const EmptyTitle = styled.span`
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const EmptyDescription = styled.span`
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
